import React from "react";
import { Tooltip } from "antd";
import { WhatsAppOutlined } from "@ant-design/icons";

const FloatingWhatsAppButton = () => {
  const phoneNumber = "917092925555";
  const message = "Hi, I visited your website and want to know more!";
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
    message
  )}`;

  return (
    <Tooltip
      title="Hi"
      placement="leftTop"
      color="#25D366"
      defaultOpen={true}
    >
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-5 right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] shadow-lg hover:scale-105 transition-transform"
      >
        <WhatsAppOutlined style={{ fontSize: "30px", color: "#fff" }} />
      </a>
    </Tooltip>
  );
};

export default FloatingWhatsAppButton;
